import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.black,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.red,
  iconBorderColor: colors.black,
  iconBorderHoverColor: colors.red
};
export default socialIcon;